import { logoutSuccess } from "../store/auth/authReducer"
import { clearFilter } from "../store/filter/filterReducer"

//The function of clearing locally saved parameters when logging out of the account
export const logOut = (dispatch) => {
  localStorage.removeItem('access_token')
  localStorage.removeItem('accesslevel')
  localStorage.removeItem('username')
  localStorage.removeItem('contactreport_filter')
  localStorage.removeItem('callreport_filter')
  localStorage.removeItem('calls_filter')
  localStorage.removeItem('conversationreport_filter')
  localStorage.removeItem('conversationdetail_filter')
  localStorage.removeItem('conversation_filter')
  localStorage.removeItem('contacts_filter')
  localStorage.removeItem('prerecordedspeech_filter')
  localStorage.removeItem('synthaudiofragments_filter')
  localStorage.removeItem('settingsupconversationtemplate_filter')
  localStorage.removeItem('optimizationtemplate_filter')
  localStorage.removeItem('knowledgebase_filter')
  localStorage.removeItem('aimodelaccess_filter')
  localStorage.removeItem('id')
  localStorage.removeItem('targetlanguage')
  localStorage.removeItem('translationCache')
  localStorage.removeItem('partner')
  localStorage.removeItem('ct_webrtc')
  localStorage.removeItem('visitedDetailsIds')
  localStorage.removeItem('va_config')
  localStorage.removeItem('va_history')
  localStorage.removeItem('va_context')
  localStorage.removeItem('va_blocks_collapsed')
  localStorage.removeItem('sa_blocks_collapsed')
  localStorage.removeItem('sa_config')
  localStorage.removeItem('sa_history')
  localStorage.removeItem('remembered_conversations')
  localStorage.removeItem('assistant_unique_token')
  dispatch(logoutSuccess())
  dispatch(clearFilter())
  window.location.reload()
}